import { Link } from "react-router-dom";

interface CrossLink {
  label: string;
  heading: string;
  description: string;
  icon: string;
  productId: string;
  productName: string;
}

const crossLinks: Record<string, CrossLink> = {
  "growth-marketing": {
    label: "Seamless Handoff",
    heading: "Turn Leads Into Deals with Sales & CRM",
    description:
      "Every lead you capture in Growth & Marketing flows directly into the Sales & CRM pipeline. Qualified leads get auto-assigned, tracked through deal stages, and converted into revenue — no manual handoff, no lost opportunities.",
    icon: "ri-exchange-dollar-line",
    productId: "sales-crm",
    productName: "Sales & CRM",
  },
  "sales-crm": {
    label: "Fuel Your Pipeline",
    heading: "Generate More Leads with Growth & Marketing",
    description:
      "Keep your pipeline full with automated campaigns, lead capture forms, and audience segmentation from Growth & Marketing. Every new prospect flows directly into your deal pipeline ready for follow-up.",
    icon: "ri-megaphone-line",
    productId: "growth-marketing",
    productName: "Growth & Marketing",
  },
};

interface Props {
  productId: string;
}

export default function CrossLinkSection({ productId }: Props) {
  const link = crossLinks[productId];
  if (!link) return null;

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-2xl border border-emerald-accent/20 bg-gradient-to-r from-emerald-accent/5 via-emerald-accent/10 to-emerald-accent/5 p-8 md:p-10">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-emerald-accent/15 border border-emerald-accent/30 shrink-0">
                <i className={`${link.icon} text-2xl text-emerald-accent`} />
              </div>
              <div className="flex-1 min-w-0">
                <span className="inline-block px-3 py-1 rounded-full bg-emerald-accent/15 border border-emerald-accent/25 text-xs font-semibold text-emerald-accent mb-3">
                  {link.label}
                </span>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
                  {link.heading}
                </h2>
                <p className="text-sm md:text-base text-silver-300 leading-relaxed max-w-2xl">
                  {link.description}
                </p>
              </div>
              <Link
                to={`/products/${link.productId}`}
                className="btn-primary shrink-0 text-sm whitespace-nowrap cursor-pointer"
              >
                Explore {link.productName}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}